const PassportRelationships = [
  "Admin",
  "Business Partner",
  "Director",
  "Employee",
  "Family Member",
  "Partner",
  "Sibling",
  "Spouse",
  "Other",
];

export const PASSPORT_RELATIONSHIP_OPTIONS = PassportRelationships.map(name => ({id: name, name}));

export default PassportRelationships;
